var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"expand-menu"},on:{"after-enter":_vm.afterTransition,"after-leave":_vm.afterTransition}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }